import getDiffComments from './src/common/util/get-diff-comments';
import Diff from './src/ui/diff/diff-content';
import LineAnnotation from './src/ui/diff/line-annotation';

export { getDiffComments, LineAnnotation };

export * from './src/ui/diff/diff-content';

export type {
  ChunkEntry,
  DiffContent,
  Line,
  OnAddCommentArgs,
} from './src/common/types';
export {
  AnnotationSeverityIcon,
  AnnotationResultIcon,
} from './src/ui/diff/line-annotation';
export {
  getCurrentLineAnnotations,
  getOutdatedLineAnnotations,
} from './src/common/util/get-line-annotations';

export default Diff;
